import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { getDeviceProfile } from '@/utils/device'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

window.service = service

// request interceptor
service.interceptors.request.use(
  async(config) => {
    // ✅ 关键：先拷贝一份 headers，避免 require-atomic-updates
    const headers = { ...(config.headers || {}) }

    // FormData 兼容：保持你现在的逻辑
    if (!(config.data instanceof FormData)) {
      headers['Content-Type'] = 'application/json;charset=utf-8'
    }

    // token：保持你现在的逻辑
    if (store.getters.token) {
      headers.Authorization = 'Bearer ' + getToken()
    }

    // 语言：保持你现在的逻辑
    const language = store.getters.language
    const langMap = store.getters.langMap
    if (language in langMap) {
      headers['Locale-Language'] = langMap[language]
    }

    // 设备信息：仍然是 await 获取，但只改本地 headers，最后一次性回填
    try {
      const d = await getDeviceProfile()

      headers['X-Device-Id'] = d.id
      headers['X-Device-Ts'] = d.ts
      headers['X-Device-Tz'] = d.tz
      headers['X-Device-Platform'] = d.platform
      headers['X-Device-Screen'] = d.screen
      headers['X-Device-Cpu'] = d.cpu
      headers['X-Device-Mem'] = d.mem
    } catch (e) {
      // ignore
    }

    Object.assign(config.headers, headers)
    return config
  },
  (error) => Promise.reject(error)
)

const subscribers = []
let isRefreshing = true

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code !== 0) {
      // ACCESS TOKEN TIMEOUT
      if (res.code === 106) {
        if (isRefreshing) {
          store.dispatch('user/refreshToken').then(() => {
            subscribers.forEach((callback) => {
              callback()
            })
            isRefreshing = true
          })
        }
        isRefreshing = false

        return new Promise((resolve) => {
          subscribers.push(() => {
            resolve(service(response.config))
          })
        })
      } else if (res.code === 104 || res.code === 107 || res.code === 401) { // Token expires;
        // to re-login
        MessageBox.confirm('登陆已过期，是否重新登陆？', '登陆提示', {
          confirmButtonText: '重登',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        }).catch(() => {
          isRefreshing = true
        })

        return Promise.reject('登陆已过期')
      }

      // 通用错误
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })

      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // eslint-disable-next-line no-console
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
